<app-row class="no-gutters nowrap add-button-wrapper ">
  <app-col>
    <button mat-flat-button class="d-block py-1 px-2 btn--start flex align-center" [color]="color" (click)="navigateToTemplate(ShipmentTemplateTypes.Basic)">
      <app-icon name="add-circle" class="mr-2" size="xs"></app-icon>
      <span class=" small weight-normal">{{'Buttons.AddNewShipment' | translate}}</span>
    </button>
  </app-col>
  <app-col cols="auto">
    <button class="small"  mat-flat-button [matMenuTriggerFor]="templatesMenu" class="btn--end p-1  mw-auto" [color]="color">
      <app-icon name="keyboard_arrow_down" type="MaterialDesign" class="" size="xs"></app-icon>
    </button>
  </app-col>
</app-row>

<mat-menu #templatesMenu="matMenu" xPosition="before">
  <ng-container *ngFor="let template of ShipmentTemplateTypes | enumToArray">
    <button class="small"  *ngIf="template.value !== ShipmentTemplateTypes.Basic && template.value !== ShipmentTemplateTypes.Bidding" mat-menu-item (click)="navigateToTemplate(ShipmentTemplateTypes[template.key])">
      {{('Enum.ShipmentCreationTemplateTypes.' + template.value) | translate}}
    </button>
  </ng-container>

  <button class="small" mat-menu-item (click)="navigateToBulkShipments()">
    {{ 'Buttons.CreateBulkShipments' | translate }}
  </button>
</mat-menu>
